import { useState, useCallback, useMemo } from 'react';
import { calculateServiceCharge } from '../utils/calculations';

export const useOrder = () => {
  const [order, setOrder] = useState([]);
  const [currentSuggestions, setCurrentSuggestions] = useState([]);

  const addItemToOrder = useCallback((item) => {
    const existingIndex = order.findIndex(orderItem => orderItem.itemId === item._id);
    
    if (existingIndex !== -1) {
      setOrder(prev => {
        const updated = [...prev];
        updated[existingIndex].quantity += 1;
        return updated;
      });
    } else {
      setOrder(prev => [...prev, { 
        itemId: item._id, 
        name: item.itemName, 
        price: item.itemPrice, 
        quantity: 1 
      }]);
    }

    if (item.suggestedItems?.length > 0) {
      setCurrentSuggestions(prev => {
        const combined = [...prev, ...item.suggestedItems];
        return combined.filter((curr, index, self) =>
          index === self.findIndex(i => i._id === curr._id)
        );
      });
    }
  }, [order]);

  const removeItem = useCallback((itemId) => {
    setOrder(prev => prev.filter(orderItem => orderItem.itemId !== itemId));
  }, []);

  const increaseQuantity = useCallback((itemId) => {
    setOrder(prev => prev.map(orderItem =>
      orderItem.itemId === itemId 
        ? { ...orderItem, quantity: orderItem.quantity + 1 } 
        : orderItem
    ));
  }, []);

  const decreaseQuantity = useCallback((itemId) => {
    setOrder(prev => prev.map(orderItem => {
      if (orderItem.itemId === itemId) {
        const newQuantity = orderItem.quantity - 1;
        return newQuantity > 0 ? { ...orderItem, quantity: newQuantity } : null;
      }
      return orderItem;
    }).filter(item => item !== null));
  }, []);

  const clearOrder = useCallback(() => {
    setOrder([]);
    setCurrentSuggestions([]);
  }, []);

  const clearSuggestions = useCallback(() => {
    setCurrentSuggestions([]);
  }, []);

  const calculations = useMemo(() => {
    const totalAmount = order.reduce((acc, item) => acc + item.price * item.quantity, 0);
    
    const serviceCharge = calculateServiceCharge(totalAmount);

    return { totalAmount, serviceCharge };
  }, [order]);

  return {
    order,
    currentSuggestions,
    addItemToOrder,
    removeItem,
    increaseQuantity,
    decreaseQuantity,
    clearOrder,
    clearSuggestions,
    ...calculations
  };
};